import {otsBaseApi} from "../../ots-api";
import {ObjectDocumentAssoc, ObjectDocumentAssocUpload} from "../../../model/object-document-assoc";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ["ObjectDocumentAssocs", "ObjectObjectDocumentAssocs"]});

const objectDocumentAssocApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllObjectDocumentAssocsByObject: builder.query<ObjectDocumentAssoc[], string>({
      query: (objectId) => ({
        url: `/object-document/all/object/${objectId}`,
        method: "GET",
      }),
      providesTags: (_result, _error, arg, _meta) => {
        return [{type: 'ObjectObjectDocumentAssocs', id: arg}];
      },
    }),
    createObjectDocumentAssoc: builder.mutation<void, ObjectDocumentAssocUpload>({
      query: (objectDocumentAssoc) => {
        const formData = new FormData()
        formData.append("file", objectDocumentAssoc.file)

        const dto : any = {...objectDocumentAssoc}
        dto["@type"] = "ObjectDocumentAssoc"
        delete dto["file"]

        formData.append("dto",  new Blob([JSON.stringify(dto)], {
          type: "application/json"
        }))

        return ({
          url: '/object-document/upload',
          method: 'POST',
          body: formData,
          formData: true
        })
      },
      invalidatesTags: (result, error, arg, meta) => {
        return [
          {type: 'ObjectObjectDocumentAssocs', id: arg.objectId},
        ]
      }
    }),
    updateObjectDocumentAssoc: builder.mutation<ObjectDocumentAssoc, Partial<ObjectDocumentAssoc>>({
      query: (objectDocumentAssoc) => ({
        url: '/object-document',
        method: 'PUT',
        body: objectDocumentAssoc,
      }),
      invalidatesTags: (result, error, {id, objectId}) => [
        {type: 'ObjectDocumentAssocs', id},
        {type: 'ObjectObjectDocumentAssocs', id: objectId},
      ],
    }),
    deleteObjectDocumentAssoc: builder.mutation<void, Partial<ObjectDocumentAssoc>>({
      query: (objectDocumentAssoc) => ({
        url: `/object-document/${objectDocumentAssoc.id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, {id, objectId}) => [
        {type: 'ObjectDocumentAssocs', id},
        {type: 'ObjectObjectDocumentAssocs', id: objectId},
      ],
    }),
  })
});

export const {
  useGetAllObjectDocumentAssocsByObjectQuery,
  useCreateObjectDocumentAssocMutation,
  useUpdateObjectDocumentAssocMutation,
  useDeleteObjectDocumentAssocMutation,
} = objectDocumentAssocApi;
